// extracted by mini-css-extract-plugin
module.exports = {"pricing_info":"PricingInfo_pricing_info__4nPQe","small":"PricingInfo_small__qMNSg","discount_tag":"PricingInfo_discount_tag__kXM3X"};